import { useQuery } from '@tanstack/react-query'
import { User, UserSettings } from '@vae/server/dist/client'
import { getCustomAccessToken } from '../../authentication/utilities'
import { trpc } from '../../modules/trpc'

const useUser = () => {
	const utils = trpc.useContext()

	const { data: accessToken, isLoading: isTokenLoading } = useQuery({
		queryKey: ['customAccessToken'],
		queryFn: getCustomAccessToken,
		staleTime: Infinity, // Keep it cached so it doesn't refetch constantly
	})

	const {
		data: session,
		isLoading: isUserLoading,
		error,
	} = trpc.user.currentUser.useQuery(undefined, {
		enabled: !!accessToken,
	})

	const editUserMutation = trpc.user.update.useMutation({
		onSuccess() {
			utils.user.currentUser.invalidate()
		},
	})

	const editSettings = trpc.user.userSettings.edit.useMutation({
		onSuccess() {
			utils.user.userSettings.get.invalidate()
		},
	})

	const editUser = async (values: Partial<User>) => {
		if (!session?.user?.id) return
		await editUserMutation.mutateAsync({
			id: session.user.id, // Not actually used, TODO to remove
			fieldsToEdit: values,
		})
	}

	const editUserSettings = async (values: Partial<UserSettings>) => {
		await editSettings.mutateAsync({
			userId: 0, // Not actually used, TODO to remove
			data: values,
		})
	}

	const completedRegistration =
		!!session?.user?.email && session.user.email.includes('@') && session.user.termsAccepted
	const isInitialLoad = isTokenLoading || (isUserLoading && !!accessToken)

	return {
		user: session?.user || null,
		userSettings: session?.user.userSettings,
		setUser: editUser,
		setUserSettings: editUserSettings,
		accessToken,
		isAuthenticated: !!session?.isAuthenticated,
		isLoading: isInitialLoad,
		error,
		isCustomer: session?.isCustomer,
		completedRegistration,
	}
}
export default useUser
